import React from "react";
import { convertDate } from "./ViewLogsHelper";
import {
  DELAY_MARKING_RADIO_BTN,
  MY_VACATIONS,
  UPDATE_SCHEDULE,
  VIEW_CALENDAR,
} from "../Constants";
import ReadMoreContent from "../../../common/ReadMoreComponent";

const ViewLogsCell = ({ cellData, logType, selectedRadioBtn }) => {
  let splitData = false;
  const splitActions = (data) => {
    let splitData = data?.split("\n");
    return splitData;
  };

  const contentText = !splitData
    ? cellData["action"]
    : splitActions(cellData["action"])?.filter(act => act !== "").join("<br>");

  const renderCell = (data) => {
    return (
      <div className="mx-1 d-flex justify-content-between align-items-center">
        <div className="view-logs-table-cell col-2">
          {cellData["created_at"] ? (
            <div>
              <span className="view-logs-table-cell-date">
                {convertDate(cellData["created_at"])[0]}
              </span>{" "}
              <span className="view-logs-table-cell-time">
                {convertDate(cellData["created_at"])[1]}
              </span>
            </div>
          ) : (
            "-"
          )}
        </div>
        {(logType === UPDATE_SCHEDULE ||
          logType === VIEW_CALENDAR ||
          (logType === MY_VACATIONS &&
            selectedRadioBtn === DELAY_MARKING_RADIO_BTN)) && (
            <div className="view-logs-table-cell col-2">
              {cellData["consultation"] ? cellData["consultation"] : "-"}
            </div>
          )}
        <div className="view-logs-table-cell col-3">
          {cellData["action"] ? (
            <ReadMoreContent
              text={contentText}
              title1={"See more"}
              title2={"See less"}
              lines={20}
              truncatedEndingComponent={"... "}
            />

          ) : (
            "-"
          )}
        </div>
        <div className="view-logs-table-cell col-2">
          {cellData["role"] ? cellData["role"] : "-"}
        </div>
        <div className="view-logs-table-cell col-2 text-capitalize">
          {cellData["role_name"] ? cellData["role_name"] : "-"}
        </div>
      </div>
    );
  };
  return (
    <div className="d-flex justify-content-between align-items-center view-logs-table my-2 mr-2">
      <div className="p-2 w-100">{cellData && renderCell(cellData)}</div>
    </div>
  );
};
export default ViewLogsCell;
